import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailContainer = styled.div<React.CSSProperties>`
  background: linear-gradient(180deg, #010101 55%, #525252);
  position: fixed;
  height: ${1080 * Screen.widthRatio}px;
  width: ${1920 * Screen.widthRatio}px;
`;

export default DetailContainer;
